import { AppModal } from 'shared/UI/UIKit/Modal';
import { DateForm } from 'features/production-calendar/components/Form';
import type { Month } from 'features/production-calendar/components/types';
import type { CalendarEvent } from 'features/production-calendar/components/List/model/types';
import { DateModalFooter } from '../../Footer';
import { useEditDateService } from '../model';

interface EditDateModalProps {
  visible: boolean;
  onItemEdit: () => void;
  hide: () => void;
  calendarEvent: CalendarEvent | null;
  calendarYear?: string;
  calendarMonth?: Month;
}

export const EditDateModal = ({
  visible,
  onItemEdit,
  hide,
  calendarYear = '',
  calendarMonth,
  calendarEvent,
}: EditDateModalProps) => {
  const {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  } = useEditDateService({ hide, onItemEdit, calendarEvent });

  const footer = <DateModalFooter onSubmit={onSubmit} hideModal={hideModal} title="Сохранить" />;
  const content = (
    <DateForm form={form} calendarYear={calendarYear} calendarMonth={calendarMonth!} />
  );

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      maskClosable={false}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Редактировать дату"
    />
  );
};
